function initClient(callback: (c: string) => void) {
  if (window.google) {
    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
      scope: 'openid email profile https://www.googleapis.com/auth/adwords',
      callback: (tokenResponse) => {
        callback(tokenResponse.code)
      },
      redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
    })

    client.requestCode()
  }
}

export const getSsoCode = (callback: (c: string) => void) => {
  initClient(callback)
}
